<template lang="html">
  <section class="feedback-account-channel-goals-container">
    <div class="field-container">
      <label class="query-label">
        {{ $t("fields") }}
      </label>
      <div class="selected-fields">
        <ul>
          <li v-for="field in selectedFields" :key="field.name">
            {{ field.label }}
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "feedback-account-channel-goals-container",
  props: {
    deId: String,
    appId: String
  },
  computed: {
    ...mapState({
      apps: "apps",
      messages: "messages"
    }),
    app() {
      return this.apps.find(app => app.uuid === this.appId);
    },
    de() {
      return this.app.dataElements[this.deId];
    },
    selectedFields() {
      if (!this.de || !this.de.selectedFields) {
        return [];
      }
      return this.de.selectedFields.map(field => {
        return {
          name: field.name,
          label: field.label
        };
      });
    }
  }
};
</script>

<style scoped lang="scss">
.field-container {
  display: flex;
}

.query-label {
  font-size: 0.85rem;
  font-weight: bold;
  flex-basis: 20%;
}

.selected-fields {
  display: inline-block;
  flex-basis: 80%;
}

.selected-fields ul {
  list-style-type: none;
  padding-left: 0;
}

.selected-fields li {
  display: flex;
}
</style>
